export const PORTAL_VOICE_LAUNCHER_CONTEXT_EVENT = 'aumhum:portal-voice-launcher-context'
const PORTAL_VOICE_LAUNCHER_CONTEXT_STORAGE_KEY = '__aumhumPortalVoiceLauncherContext'

function normalizeLauncherContext(detail, sourceKey) {
  if (!detail) {
    return null
  }

  if (!sourceKey) {
    return detail
  }

  return {
    ...detail,
    contextSourceKey: sourceKey,
  }
}

export function publishPortalVoiceLauncherContext(detail, sourceKey) {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return
  }

  const nextDetail = normalizeLauncherContext(detail, sourceKey)
  window[PORTAL_VOICE_LAUNCHER_CONTEXT_STORAGE_KEY] = nextDetail

  window.dispatchEvent(
    new window.CustomEvent(PORTAL_VOICE_LAUNCHER_CONTEXT_EVENT, {
      detail: nextDetail,
    }),
  )
}

export function getPortalVoiceLauncherContext() {
  if (typeof window === 'undefined') {
    return null
  }

  return window[PORTAL_VOICE_LAUNCHER_CONTEXT_STORAGE_KEY] || null
}

export function clearPortalVoiceLauncherContext(expectedSourceKey) {
  if (typeof window === 'undefined') {
    return
  }

  const currentContext = getPortalVoiceLauncherContext()
  if (
    expectedSourceKey &&
    currentContext?.contextSourceKey &&
    currentContext.contextSourceKey !== expectedSourceKey
  ) {
    return
  }

  publishPortalVoiceLauncherContext(null)
}
